import Repository from './Repository'

const resource = 'secretaries'

export default {
  getSecretaries (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  }
}
